import React from 'react';
type MechanismNodeProps = {
  label: string;
  dimmed: boolean;
  compact: boolean;
};
export function MechanismNode({
  label,
  dimmed,
  compact
}: MechanismNodeProps) {
  return <div className={compact ? 'py-1' : 'w-56 shrink-0 py-1'} data-id="element-54" data-mp="128lmb9o39k6u">
      <span className={`block font-display tracking-[-0.015em] transition-colors duration-300 ease-out ${compact ? 'text-[1.4rem] leading-snug' : 'text-[1.75rem] leading-snug'} ${dimmed ? 'text-faint' : 'text-ink'}`} data-id="element-55" data-mp="12a51sy1x7r7k">
        {label}
      </span>
    </div>;
}